import { Box, Button, makeStyles, PopperPlacementType } from '@material-ui/core';
import GetAppIcon from '@material-ui/icons/GetApp';
import { useSnackbar } from 'notistack';
import React, { useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import ConfirmationDialog from '../../../../../../../components/ConfirmationDialog';
import { ActionLink } from '../../../../../../../components/TableGrid/TableGridToolbar/ActionBox/ActionBox.type';
import { FontSizes } from '../../../../../../../core/config/mainTheme';
import { useErrorsDispatch } from '../../../../../shared/ErrorContext/ErrorContext';
import { ErrorContextActionTypes } from '../../../../../shared/ErrorContext/ErrorContext.types';

export interface Props {
  buttonTitle?: string;
  actionItem: ActionLink;
  totalElements?: number;
  selectedRows: number;
  placement?: PopperPlacementType;
}

const FileDownload: React.FC<Props> = ({
  buttonTitle,
  actionItem,
  totalElements,
  selectedRows,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const [openConfDialog, setConfDialog] = useState(false);
  const [confText, setConfText] = useState('app:confirmationText:defaultText');
  const [currentItem, setCurrentItem] = useState<ActionLink>();
  const [visibleCount, setVisibleCount] = useState<number>(0);
  const dispatchErrors = useErrorsDispatch();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  useEffect(() => {
    if (totalElements && totalElements > 0 && selectedRows <= 0) {
      setVisibleCount(totalElements);
    } else {
      setVisibleCount(selectedRows);
    }
  }, [totalElements, selectedRows]);

  const hanldeOpenConfirmation = (item?: any) => {
    setConfText(`app:confirmationText:${item.title}`);
    setCurrentItem(item);
    setConfDialog(true);
  };

  const handleCloseConfirmation = () => {
    setConfDialog(false);
  };

  const handleOkConfirmation = async () => {
    setConfDialog(false);
    let infoSnack;
    if (currentItem?.snackbarReportText) {
      infoSnack = enqueueSnackbar(<Trans i18nKey={currentItem.snackbarReportText} />, {
        variant: 'info',
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'right',
        },
      });
    }
    if (currentItem && currentItem.onClick) {
      try {
        await currentItem.onClick();
      } catch (error) {
        if (infoSnack) {
          closeSnackbar(infoSnack);
        }
        dispatchErrors({
          type: ErrorContextActionTypes.SetError,
          payload: { error },
        });
      }
    }
  };

  return (
    <Box className={`${classes.rightBox}`}>
      <Button
        onClick={() => hanldeOpenConfirmation(actionItem)}
        className={classes.btn}
        startIcon={<GetAppIcon />}
        size="small"
        color="primary"
        disabled={visibleCount <= 0 ? true : false}
      >
        {t(`${buttonTitle}`)} ({visibleCount})
      </Button>
      <ConfirmationDialog
        open={openConfDialog}
        handleClose={handleCloseConfirmation}
        handleConfirmOk={handleOkConfirmation}
        text={confText}
      />
    </Box>
  );
};

const useStyles = makeStyles(() => ({
  rightBox: {
    marginLeft: 'auto',
    position: 'relative',
    display: 'flex',
  },
  btn: {
    textTransform: 'none',
    fontWeight: FontSizes.fontWeight.bold,
  },
}));

export default FileDownload;
